import { Component, ViewChild } from '@angular/core';
import { TableService } from '../../../../_services/table.service';
import { LazyLoadEvent } from 'primeng/api';
import { TableModule } from 'primeng/table';
import { CommonModule } from '@angular/common';
import { HighlightDirective } from '../../../../_directives/highlight.directive';
import { Table } from 'primeng/table';

@Component({
  selector: 'app-card-view',
  standalone: true,
  imports: [CommonModule, TableModule, HighlightDirective],
  templateUrl: './card-view.component.html',
  styleUrl: './card-view.component.scss',
})
export class CardViewComponent {
  products_current_datasource: any[] = [];
  cols: any[] = [];
  TableRowsCounts: any[] = [];
  searchedWords: any = [];
  globalfilterFields: any;
  loading_table: boolean = false;
  totalRecords = 0;
  first = 0;
  @ViewChild('dt') dataTable!: Table;
  current_pagenumber: number = 1;
  rows: any = 50;
  cardViewTemplate: any;
  scrollHeight = '250px';
  productDdetailView = false;
  secondaryTableDetails: any[] = []; // Changed to array
  imageBaseUrls = {};
  selectedRow = '';
  viewFields: any = [
    {
      fields: [
        {
          field: 'companyName',
          displayColumnName: '',
          table: 'INDIAN_PESTICIDE_DATABASE_MONGO',
        },
        {
          field: 'indication',
          displayColumnName: '',
          table: 'basic_product_details_MONGO',
        },
        {
          field: 'apprStatus',
          displayColumnName: '',
          table: 'INDIAN_PESTICIDE_DATABASE_MONGO',
        },
      ],
    },
    {
      fields: [
        {
          field: 'originalRmrkfrm_Cibrc',
          displayColumnName: 'Original Remarks From CIBRC',
          table: 'INDIAN_PESTICIDE_DATABASE_MONGO',
        },
      ],
    },
  ];
  isShowReadMoreDialog: boolean = false;
  isShowReadMoreEditDialog: boolean = false;
  readMoreColumn: string = '';
  readMoreContent: string = '';

  constructor(private tableService: TableService) {}

  ngOnInit(): void {
    this.tableService.getProductCurrentDatasource().subscribe((data) => {
      this.products_current_datasource = data.map((obj) => ({ ...obj }));
      this.scrollHeight =
        this.products_current_datasource.length < 6
          ? this.products_current_datasource.length * 100 + 150 + 'px'
          : '1285px';
      this.clickProduct(data[0]);
    });

    this.getCols();

    this.tableService.getCols().subscribe((data) => {
      this.cols = [...data];
    });

    this.tableService.getTotalRecords().subscribe((data) => {
      this.totalRecords = data;
    });

    this.tableService.getTableState().subscribe((data) => {
      this.rows = data.rows;
      this.current_pagenumber = data.pageNumber;
      this.setPageNumber();
    });

    this.tableService.getDetailViewTemplate().subscribe((data) => {
      this.cardViewTemplate = data.template.card_view;
    });

    this.tableService.getTableRowsCounts().subscribe((data) => {
      this.TableRowsCounts = data;
    });

    this.tableService.getProductDetailView().subscribe((data) => {
      this.productDdetailView = data;
    });

    // Updated to handle flat array structure
    this.tableService.getSecondaryTableDetails().subscribe((data) => {
      this.secondaryTableDetails = data;
      this.setLinks();
      this.getCols();
    });

    this.tableService.getImagesBaseUrl().subscribe((data) => {
      this.imageBaseUrls = data;
    });

    this.tableService.getSearchedWords().subscribe((data) => {
      this.searchedWords = data;
    });
  }

  setLinks() {
    this.secondaryTableDetails.forEach((x: any) => {
      if (x.activeIngredient) {
        let link =
          x.activeIngredient.substring(0, x.activeIngredient.indexOf('('))
            .trim()
            .replace(/[^a-zA-Z0-9]/g, '') + x.gbrn;
        x.link = link;
      }
    });
  }

  getCols() {
    this.tableService.getCols().subscribe((data) => {
      this.cols = data.map((obj) => ({ ...obj }));
      this.setViewFields();
    });

    // this.cols.forEach((col) => {
    //   if (col.card_view_order) {
    //     col.rowOrderCard = col.card_view_order
    //       ? parseInt(col.card_view_order.substring(0, 2))
    //       : '';
    //     col.colOrderCard = col.card_view_order
    //       ? parseInt(col.card_view_order.substring(2, 4))
    //       : '';
    //     col.cardColOrderCard = col.card_view_order
    //       ? parseInt(col.card_view_order.substring(4))
    //       : '';
    //   }
    // });

    // this.cols.sort((a, b) => {
    //   const rowOrderA = isNaN(a.rowOrderCard) ? Infinity : a.rowOrderCard;
    //   const colOrderA = isNaN(a.colOrderCard) ? Infinity : a.colOrderCard;
    //   const cardColOrderA = isNaN(a.cardColOrderCard)
    //     ? Infinity
    //     : a.cardColOrderCard;

    //   const rowOrderB = isNaN(b.rowOrderCard) ? Infinity : b.rowOrderCard;
    //   const colOrderB = isNaN(b.colOrderCard) ? Infinity : b.colOrderB;
    //   const cardColOrderB = isNaN(b.cardColOrderCard)
    //     ? Infinity
    //     : b.cardColOrderCard;

    //   if (rowOrderA !== rowOrderB) {
    //     return rowOrderA - rowOrderB;
    //   } else if (colOrderA !== colOrderB) {
    //     return colOrderA - colOrderB;
    //   } else {
    //     return cardColOrderA - cardColOrderB;
    //   }
    // });
  }

  setViewFields() {
    this.viewFields.forEach((val: any) => {
      val.fields.forEach((col: any) => {
        col.displayColumnName = this.cols.filter(
          (cl) => cl.field === col.field
        )[0].displayColumnName;
      });
    });
  }

  addDataSpace(data: any) {
    data = data.replace(/\n|\r\n/gm, '<br/>');
    return data != null ? data.toString().replace(/;/gi, '; ') : data;
  }

  showReadMore(column: any, content: any) {
    this.isShowReadMoreDialog = true;
    this.readMoreColumn = column;
    this.readMoreContent = content.replace(/;/gi, '; ');
    this.readMoreContent = this.readMoreContent.replace(/\n|\r\n/gm, '<br/>');
  }

  // REMOVED: Old addSecTableData() - no longer needed

  clickProduct(rowData: any) {
    this.selectedRow = rowData._id;
    this.tableService.sendDetailViewProduct(rowData);
  }

  // SIMPLIFIED: Check if product has secondary table data
  hasSecondaryData(rowData: any): boolean {
    return rowData.gbrn_products && rowData.gbrn_products.length > 0;
  }

  // NEW: Get secondary data for a specific product
  getSecondaryDataForProduct(rowData: any): any[] {
    return rowData.gbrn_products || [];
  }

  loadProducts(event: any) {
    this.current_pagenumber = (event.first ?? 0) / (event.rows ?? 10) + 1;
    this.rows = event.rows ?? 50;
    let data = {
      searchData: true,
      pageNumber: this.current_pagenumber,
      rows: this.rows,
    };
    this.tableService.sendTableStateWithDataSearch(data);
  }

  setCurrentPage(n: number) {
    let paging = {
      first: (n - 1) * (this.dataTable.rows ?? 10),
      rows: this.dataTable.rows ?? 10,
    };
    this.first = paging.first;
    this.dataTable.onPageChange(paging);
  }

  setPageNumber() {
    this.first = (this.current_pagenumber - 1) * this.rows;
  }

  getClassWidth(template_col: any) {
    return this.productDdetailView
      ? `card-col-${template_col}1`
      : `card-col-${template_col}`;
  }

  valueIsArray(rowData: any) {
    return Array.isArray(rowData);
  }

  isLongText(text: string): boolean {
  if (!text) return false;
  const wordCount = text.trim().split(/\s+/).length;
  return wordCount > 15;
}

}
